module.exports = __webpack_public_path__ + "static/media/Braga_arcada.272c21d3.jpg";